import type { AxiosError } from "axios";
import { AppActions, SearchResultActions } from "../../redux/reducer";
import store from "../../redux/store";

export const errHandler = (error: AxiosError) => {
  const isTimeOut = () => error.message.indexOf("timeout") > -1;
  // all time out error go to 503 error page
  if (isTimeOut()) {
    store.dispatch(AppActions.setErrorPage(true));
    return Promise.reject(error);
  }
  // not add 999 wishList error here
  // wish icon api error type c
  if (
    error.config.url &&
    error.config.url.indexOf("/favorites") !== -1 &&
    error.config.url.indexOf("/favorites?allL2s=true") === -1
  ) {
    // if search favorites return
    if (
      error.config.url &&
      (error.config.url.includes("/favorites/search") ||
        error.config.url.includes("/favorites/styles/search"))
    ) {
      const mockErrorRes = { status: "nok" };
      return Promise.resolve(mockErrorRes);
    }
    store.dispatch(AppActions.setServerErrorModal(true));
    return Promise.reject(error);
  }
  // item wish popup skuList api error, do not show the system error modal, because in wish popup logic there is a error modal itself.
  else if (
    error.config.url &&
    error.config.url.indexOf("/favorites?allL2s=true") !== -1
  ) {
    return Promise.reject(error);
  }
  // filter or sort product error
  else if (error.config.url && error.config.url.includes("/product")) {
    const searchResult = store.getState().searchResult;
    // if changed sort or filter then show error wording.
    if (
      searchResult.isChangeItemSortFlag ||
      searchResult.isChangedItemFilterFlag
    ) {
      store.dispatch(SearchResultActions.setChangedItemFilterSortError(true));
    } else {
      store.dispatch(AppActions.setErrorPage(true));
    }
  }
  // filter outfit error
  else if (error.config.url && error.config.url.includes("/outfits/search")) {
    const searchResult = store.getState().searchResult;
    // if changed sort or filter then show error wording.
    if (
      searchResult.isChangedOutfitFilterFlag ||
      searchResult.isChangeOutfitSortFlag
    ) {
      store.dispatch(SearchResultActions.setChangedOutfitFilterSortError(true));
    } else {
      store.dispatch(AppActions.setErrorPage(true));
    }
  } else {
    // handler server error
    store.dispatch(AppActions.setErrorPage(true));
  }
  return null;
};
